var _rect, _circle, _circle2, _circle3, _g, _g2, _g3, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 408,
    viewBox: "0 0 514 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.2795,
    y: 61.5073,
    width: 429,
    height: 311,
    rx: 10,
    fill: "white",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.28,
    cy: 91.5073,
    r: 5,
    fill: "#FC165B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.28,
    cy: 91.5073,
    r: 5,
    fill: "#FCA016"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.28,
    cy: 91.5073,
    r: 5,
    fill: "#16FCA9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_59_751)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.9406,
    cy: 185.168,
    r: 15.7675,
    transform: "rotate(-34.7184 25.9406 185.168)",
    fill: "url(#paint0_linear_59_751)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_59_751)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 344.22,
    cy: 18.4483,
    r: 8.22721,
    transform: "rotate(-34.7184 344.22 18.4483)",
    fill: "url(#paint1_linear_59_751)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_59_751)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 440.607,
    cy: 376.771,
    r: 21.0298,
    transform: "rotate(-34.7184 440.607 376.771)",
    fill: "url(#paint2_linear_59_751)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.78 125.507C193.78 124.127 194.899 123.007 196.28 123.007H402.28C403.66 123.007 404.78 124.127 404.78 125.507V372.007H193.78V125.507Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "#44C7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M397.28 284.508L406.706 307.134L410.053 297.281L419.906 293.934L397.28 284.508Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 211.28,
    y: 178.507,
    width: 176,
    height: 87,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110.28,
    y: 130,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 110.28,
    y: 163,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110.28,
    y: 196,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 110.28,
    y: 229,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 141.28,
    y: 130,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 124,
    width: 56,
    height: 55,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 196,
    width: 56,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 234,
    width: 56,
    height: 43,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 110.28,
    y: 266,
    width: 52,
    height: 59,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 141.28,
    y: 163,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 141.28,
    y: 196,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 141.28,
    y: 229,
    width: 21,
    height: 21,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 211.28,
    y: 274.508,
    width: 84,
    height: 87,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 303.28,
    y: 274.508,
    width: 84,
    height: 87,
    rx: 3,
    fill: "white",
    fillOpacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 15,
    rx: 3,
    transform: "matrix(1 0 0 -1 270.28 158.507)",
    fill: "white",
    fillOpacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 3,
    transform: "matrix(1 0 0 -1 211.28 158.507)",
    fill: "white",
    fillOpacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 7,
    height: 7,
    transform: "matrix(1 0 0 -1 401.28 125.507)",
    fill: "white",
    stroke: "#44C7FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 7,
    height: 7,
    transform: "matrix(1 0 0 -1 189.28 125.507)",
    fill: "white",
    stroke: "#44C7FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_59_751",
    x: 0.171631,
    y: 159.399,
    width: 51.5379,
    height: 51.5381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_59_751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_59_751",
    x: 325.992,
    y: 0.220215,
    width: 36.4559,
    height: 36.4561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_59_751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_59_751",
    x: 409.575,
    y: 345.739,
    width: 62.0633,
    height: 62.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_59_751"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_751",
    x1: 25.9406,
    y1: 169.401,
    x2: 25.9406,
    y2: 200.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC165B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_751",
    x1: 344.22,
    y1: 10.2211,
    x2: 344.22,
    y2: 26.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1656FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_751",
    x1: 440.607,
    y1: 355.741,
    x2: 440.607,
    y2: 397.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009C3E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.63bdabaed192cc4396988f4ad5627612.svg";
export { ForwardRef as ReactComponent };